import { CustomAccordion } from 'components/CustomAccordion/CustomAccordion'
import { useContractStore } from 'context/ContractStore'
import { getValidDate } from 'lib/utils'
import React, { memo } from 'react'
import { Typography } from '@mui/material'


const ddsData = (data) => {
  if (!data) return []

  return [
    { label: 'Банк - расчетный счет', value: data?.bankDataName || 'Нет данных' },
    { label: 'Дата и время', value: getValidDate(data?.documentDate, true) || 'Нет данных' },
    { label: 'Сумма', value: data?.ddsSum?.toString()?.thousandSeparator() || 'Нет данных' },
    { label: 'КНП', value: data?.paymentPurposeCode || 'Нет данных' },
    { label: 'Номер документы', value: data?.documentNumber || 'Нет данных' },
    { label: 'Назначение платежа', value: data?.paymentPurpose || 'Нет данных' }
  ]
}

export const DDSTab = memo(() => {
  const {
    contractStore: { loanApplicationData }
  } = useContractStore()

  const ddsList = Array.isArray(loanApplicationData?.dds)
    ? loanApplicationData.dds
    : loanApplicationData?.dds
      ? [loanApplicationData.dds]
      : []

  return (
    <>
      {ddsList.length > 0 ? (
        ddsList.map((dds, index) => (
          <CustomAccordion
            key={index}
            title={
              <Typography
                sx={{
                  fontWeight: 600,
                  color: dds.type === 'expense' ? 'red' : 'green'
                }}
              >
                {dds.type === 'expense' ? 'ДДС на расход' : 'ДДС на приход'}
              </Typography>
            }
            data={ddsData(dds)}
          />
        ))
      ) : (
        <Typography sx={{fontWeight: 600,fontSize:21,textAlign:"center" }}>Нет данных по ДДС</Typography>
      )}
    </>
  )
})
